import { createUser, signInUser } from "../api/api";
import Cookies from "js-cookie";

export const registerUser = (fullname, email, password, navigate, setCookie) => async (dispatch) => {
  try {

    dispatch({
      type: 'USER_REGISTER_REQUEST'
    });
    const res = await createUser({ "name": fullname, "email": email, "password": password });

    if (res.status === 200) {

      if (res.data.access_token) {
        console.log(res.data);
        setCookie("token", res.data.access_token, process.env.SESSION_EXPIRING_TIME);
        localStorage.setItem('token', res.data.access_token);
        localStorage.setItem('userInfo', JSON.stringify(res.data.user));

        dispatch({ type: 'USER_REGISTER_SUCCESS', payload: res.data });

        navigate('/space');
      } else {
        return res.data;

      }
    } else {
      dispatch({ type: 'USER_REGISTER_FAIL', payload: "err" });
    }

  } catch (err) {
    dispatch({
      type: 'USER_REGISTER_FAIL',
      payload: err
    });
    return err.response?.data
  }
}


export const logoutUser = () => (dispatch) => {
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo')
  localStorage.removeItem('workspaceID')
  Cookies.remove('token');

  // Dispatch logout action to clear the Redux state
  dispatch({ type: 'USER_LOGOUT' });

}


// Login action
export const loginUser = (email, password, navigate, setCookie) => async (dispatch) => {
  try {
    dispatch({ type: 'USER_LOGIN_REQUEST' });

    const res = await signInUser({ "email": email, "password": password });

    console.log(res);
    if (res.status === 200) {
      if (res.data.access_token) {
        await new Promise((resolve) => {
          setCookie("token", res.data.access_token, { maxAge: process.env.SESSION_EXPIRING_TIME });
          localStorage.setItem('token', res.data.access_token);
          localStorage.setItem('userInfo', JSON.stringify(res.data.user));
          resolve();
        });

        dispatch({ type: 'USER_LOGIN_SUCCESS', payload: res.data });

        navigate('/space');
      } else {
        return res?.data;
      }

    } else {
      dispatch({ type: 'USER_LOGIN_FAIL', payload: 'Login failed' });
    }
  } catch (error) {
    
    // Handle errors by dispatching the fail action with the error message
    dispatch({
      type: 'USER_LOGIN_FAIL',
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : 'Invalid username or password',
    });
  }
};
